import React from 'react';
import { Button, TextButton } from '@wix/design-system';
import { Icons } from '../Icons';
import { deepLoopObjectAndTransformStringProperties } from './utils';
export const WidgetButton = _ref => {
  let {
    children,
    type = 'button',
    priority = 'primary',
    size = 'tiny',
    skin,
    selectedValues = [],
    selectedTitles = [],
    respondText,
    webAction,
    sideEffect,
    context,
    icon,
    className = '',
    onClick,
    disabled
  } = _ref;
  const {
    send,
    webActions,
    emitSideEffect
  } = context;
  const handleClick = () => {
    const biEffects = [];
    if (respondText) {
      const respondMessageContent = insertSelectedToString(respondText, selectedValues, selectedTitles);
      biEffects.push({
        effect: 'respond',
        data: {
          message: respondMessageContent
        }
      });
      send(respondMessageContent);
    }
    if (webAction) {
      if (!webActions) {
        return;
      }
      const _webAction = deepLoopObjectAndTransformStringProperties(webAction, string => {
        return insertSelectedToString(string, selectedValues, selectedTitles);
      });
      for (const [actionName, actionParams] of Object.entries(_webAction)) {
        const action = webActions[actionName];
        if (action && typeof action === 'function') {
          biEffects.push({
            effect: actionName,
            data: actionParams
          });
          try {
            action(actionParams);
          } catch (err) {
            console.error(err);
          }
        }
      }
    }
    if (sideEffect) {
      const sideEffectParams = {
        ...sideEffect.params,
        VALUES: selectedValues,
        SELECTED: selectedTitles
      };
      biEffects.push({
        effect: 'side_effect',
        data: {
          name: sideEffect.name,
          params: sideEffectParams
        }
      });
      emitSideEffect(sideEffect.name, sideEffectParams);
    }
    onClick == null || onClick(biEffects);
  };
  let prefixIcon, suffixIcon;
  if (icon != null && icon.name) {
    const Icon = Icons[icon == null ? void 0 : icon.name];
    if (Icon) {
      prefixIcon = (icon == null ? void 0 : icon.place) === 'prefix' ? /*#__PURE__*/React.createElement(Icon, null) : undefined;
      suffixIcon = (icon == null ? void 0 : icon.place) === 'suffix' ? /*#__PURE__*/React.createElement(Icon, null) : undefined;
    }
  }
  return type === 'button' ? /*#__PURE__*/React.createElement(Button, {
    size: size,
    priority: priority,
    prefixIcon: prefixIcon,
    suffixIcon: suffixIcon,
    onClick: handleClick,
    skin: skin || 'standard',
    className: className,
    disabled: disabled
  }, children) : /*#__PURE__*/React.createElement(TextButton, {
    size: size,
    prefixIcon: prefixIcon,
    suffixIcon: suffixIcon,
    onClick: handleClick,
    className: className,
    disabled: disabled,
    skin: skin || 'standard'
  }, children);
};
const insertSelectedToString = (text, selectedValues, selectedTitles) => {
  const selectedValuesString = selectedValues.join(', ');
  const selectedTitlesString = selectedTitles.join(', ');
  return text.replace(/<VALUES>/g, selectedValuesString).replace(/<SELECTED>/g, selectedTitlesString);
};
//# sourceMappingURL=WidgetButton.js.map